import React from 'react'
import Copyright from './copyright/copyright'
import FooterLinks from './footer-links/footer-links'

const FooterBottom = () => {
  return (
    <div>
      <Copyright />
      <FooterLinks />
    </div>
  )
}

export default FooterBottom
